var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef } from 'react';
import Popper from '@material-ui/core/Popper';
/** Non-modal select/calendar surface. Callers retain their existing click-away behavior. */
export function CapitalPopper(_a) {
    var { onClose, width, closeOnScroll = false, className, style, modifiers } = _a, props = __rest(_a, ["onClose", "width", "closeOnScroll", "className", "style", "modifiers"]);
    const surface = useRef(null);
    const anchor = typeof props.anchorEl === 'function' ? props.anchorEl() : props.anchorEl;
    // A nested select stays inside its parent dialog's focus boundary, without
    // being clipped by the scrolling dialog paper/content.
    const container = props.container || (anchor instanceof Element ? anchor.closest('.MuiDialog-container') : undefined);
    const close = useRef(onClose);
    close.current = onClose;
    useEffect(() => {
        if (!props.open || !closeOnScroll)
            return;
        const dismiss = (event) => {
            var _a, _b;
            // Keep long details readable; only scrolling outside the popup dismisses it.
            if (event.target instanceof Node && ((_a = surface.current) === null || _a === void 0 ? void 0 : _a.contains(event.target)))
                return;
            (_b = close.current) === null || _b === void 0 ? void 0 : _b.call(close);
        };
        window.addEventListener('scroll', dismiss, true);
        return () => window.removeEventListener('scroll', dismiss, true);
    }, [props.open, closeOnScroll]);
    useEffect(() => {
        if (!props.open)
            return;
        const previous = document.activeElement;
        const dismiss = (event) => {
            var _a;
            if (event.key !== 'Escape' || event.defaultPrevented || !close.current)
                return;
            const active = document.activeElement;
            if (active !== previous && !((_a = surface.current) === null || _a === void 0 ? void 0 : _a.contains(active)))
                return;
            event.preventDefault();
            event.stopPropagation();
            close.current();
        };
        document.addEventListener('keydown', dismiss, true);
        return () => {
            var _a;
            document.removeEventListener('keydown', dismiss, true);
            if ((previous === null || previous === void 0 ? void 0 : previous.isConnected) && (document.activeElement === document.body || ((_a = surface.current) === null || _a === void 0 ? void 0 : _a.contains(document.activeElement))))
                previous.focus();
        };
    }, [props.open]);
    return React.createElement(Popper, Object.assign({}, props, { container: container || undefined, ref: surface, className: ['capital-popper', className].filter(Boolean).join(' '), style: Object.assign(Object.assign(Object.assign({}, style), (width ? { width } : {})), { maxWidth: 'calc(100vw - 24px)', zIndex: 1301 }), modifiers: Object.assign({ offset: { enabled: true, offset: '0, 8' }, preventOverflow: { enabled: true, boundariesElement: 'viewport', padding: 12 } }, modifiers) }));
}
